export default [
  {
    resource: "administration",
    header: "Allotjaments",
  },
  {
    action: "manage",
    resource: "administration",
    icon: "HomeIcon",
    title: "Llistat",
    route: "foravila-accommodations-list",
  },
  {
    action: "manage",
    resource: "administration",
    icon: "UserXIcon",
    title: "Buits",
    route: "foravila-accommodations-empty-list",
  },
  {
    action: "manage",
    resource: "administration",
    title: "Propietaris",
    route: "foravila-owners-list",
    icon: "KeyIcon",
  },
  {
    action: "manage",
    resource: "administration",
    icon: "EditIcon",
    title: "Contractes",
    route: "foravila-contracts-list",
  },
];
